import styles from './A_ToggleButton.module.css';
import cn from 'classnames';

interface A_ToggleButtonProps {
  isActive: boolean;
  onClick: () => void;
  title?: string;
  bgColor?: 'gray' | 'white';
  icon?: React.ReactNode;
  width?: string | number;
  height?: string | number;
  padding?: string | number;
}

export default function A_ToggleButton({
  isActive,
  onClick,
  title,
  bgColor = 'gray',
  icon,
  width,
  height,
  padding,
}: A_ToggleButtonProps) {
  return (
    <button
      className={cn(styles.wrapper, styles[bgColor], {
        [styles.active]: isActive,
      })}
      onClick={onClick}
      style={{ width, padding, height }}
    >
      {icon && icon}
      {title && <span className={cn(styles.title, 'text-p-4')}>{title}</span>}
    </button>
  );
}
